var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h6',{staticClass:"card-subtitle text-muted text-center",staticStyle:{"font-size":"15px","margin-top":"5px","margin-bottom":"25px","overflow":"hidden"}},[_c('b',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }